import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { questionnaireReducerAtom } from "../state/questionnaireReducerAtom";
import { selectAtom } from "jotai/utils";

/**
 * Hook to retrieve the index of a specific section by its ID.
 * Uses a Jotai selector to only subscribe to changes for this specific index.
 * @param sectionId - The ID of the section
 * @returns The section index, or -1 if not found
 */
export const useSectionIndexById = (sectionId: string | undefined): number => {
  const sectionIndexAtom = useMemo(() => {
    if (!sectionId) {
      return selectAtom(questionnaireReducerAtom, () => -1);
    }

    return selectAtom(questionnaireReducerAtom, state =>
      state.sections.findIndex(s => s.id === sectionId),
    );
  }, [sectionId]);

  return useAtomValue(sectionIndexAtom);
};
